module.exports = __webpack_public_path__ + "static/media/fa-regular-400.b0e2db3b.eot";